import { useMutation } from '@tanstack/react-query';
import {
  type UpdateGradeSetInput,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { assessmentsKeys } from '../keys';

const updateGradeSet = graphql(/* GraphQL */ `
  mutation assessment_updateGradeSet($input: [UpdateGradeSetInput]) {
    assessment_updateGradeSet(input: $input) {
      id
    }
  }
`);

export function useUpdateGradeSet() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: (input: UpdateGradeSetInput[]) =>
      gqlClient.request(updateGradeSet, { input }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: assessmentsKeys.all });
      toast.success(t('common:snackbarMessages.updateSuccess'));
    },
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
  });
}
